/* eslint-disable */

export default `
// -----------------------------------------------------------------------------
//
//
// -----------------------------------------------------------------------------

float translate(float fromMin, float fromMax, float toMin, float toMax, float value) {
    return (((value - fromMin) / (fromMax - fromMin)) * (toMax - toMin)) + toMin;
}

float translateNorm(float fromMin, float fromMax, float value) {
    return translate(fromMin, fromMax, 0.0, 1.0, value);
}

float translateNoise2d(float value) {
    float minMax = sqrt(2.0) / 2.0;
    return translate(-minMax, minMax, 0.0, 1.0, value);
}

float translateNoise3d(float value) {
    float minMax = sqrt(3.0) / 2.0;
    return translate(-minMax, minMax, 0.0, 1.0, value);
}

float translateNoise4d(float value) {
    float minMax = sqrt(4.0) / 2.0;
    return translate(-minMax, minMax, 0.0, 1.0, value);
}
`
